export const CLIENT_RESCHEDULING = "client_rescheduling";
export const DISABLE_ONBOARDING_NOTIFICATIONS = "disable_onboarding_notifications";
export const HEALTHIE = "healthie";
export const ON_SCHEDULE = "onsched";
export const SCHEDULING_PAGE = "scheduling_page";
export const TRANSCRIPTION = "transcription";
